import { estaNoElectron } from './balanca';
import { ehAppInstalado } from './pwa-kiosk';
import { obterTenantDispositivo } from './tenant';

export function ehAparelhoKiosk(): boolean {
  return estaNoElectron() || ehAppInstalado() || !!obterTenantDispositivo();
}
